<template>
    <simple-layout horizontal>
        <users-list-card :users="users"
            @focusedChanged="handleFocusedChanged">
            <user-form-card v-if="focusedUser != null" :user="focusedUser" @save="handleSave"/>
        </users-list-card>
    </simple-layout>
</template>

<script>
    import UsersListCard from "../cards/UsersListCard";
    import {mapGetters} from "vuex";
    import SimpleLayout from "../components/layout/SimpleLayout";
    import UserFormCard from "../cards/UserFormCard";

    export default {
        name: "UsersView",
        components: {UserFormCard, SimpleLayout, UsersListCard},
        data: function () {
            return {
                focusedUser: null,
            }
        },
        methods: {
            handleFocusedChanged(focused) {
                this.focusedUser = focused;
            },
            handleDelete(item) {
                this.$store.dispatch("users/deleteUsers", item);
            },
            handleSave(user) {
                this.$store.dispatch("users/saveUser", user).then(() => {
                    this.focusedUser = null;
                })
            }
        },
        computed: {
            ...mapGetters({
                users: "users/users",
            })
        },
        mounted() {
            this.$store.dispatch("users/refreshUsers");
        }
    }
</script>

<style scoped>

</style>